import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    maxHeight: 600,
    overflow: 'hidden',
    '&.closed': {
      display: 'none',
    },
  },
  menuList: {
    minWidth: 331,
    maxHeight: 540,
    overflowY: 'auto',
    paddingBottom: 0,
  },
  customMenuPaper: {
    minWidth: 331,
    maxWidth: 420,
    borderRadius: 12,
    overflow: 'hidden',
  },
  customMenuRoot: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 600,
    backgroundColor: theme.palette.background.paper,
  },
  customMenuTopContent: {
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
  },
  customMenuListContainer: {
    overflowY: 'auto',
    minWidth: 331,
    maxHeight: 540,
    paddingBottom: 0,
    marginLeft: 8,
  },
  customMenuFooter: {
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
  },
  selectedMenuItem: {
    height: '40px',
    backgroundColor: `${theme.palette.background.paper} !important`,
    '&:hover': {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
    '&:focus': {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
  },
  subMenuItem: {
    paddingLeft: '60px',
    height: '40px',
  },
  headerMenuItem: {
    textTransform: 'capitalize',
    height: '40px',
  },
  allAccountsPadding: {
    height: '40px',
  },
  customMenuItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: 40,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  customSubMenuItem: {
    paddingLeft: theme.spacing(7.5),
  },
  customHeaderMenuItem: {
    textTransform: 'capitalize',
  },
  customAllAccountsPadding: {
    paddingLeft: theme.spacing(1),
  },
  dropdownIcon: {
    marginRight: '-10px',
    padding: '6px',
  },
  dropdownIconAllAccts: {
    marginLeft: '-20px',
    marginRight: '-10px',
    padding: '6px',
  },
  numItems: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: '8px',
    height: '25px !important',
    width: '25px !important',
    marginRight: 8,
  },
  innerNum: {
    color: theme.palette.text.contrastText,
    marginTop: 'auto',
    marginBottom: 'auto',
    lineHeight: '25px',
  },
  textContainer: {
    height: 24,
    maxHeight: 24,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginLeft: 15,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'center',
  },
  textBox: {
    marginTop: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontWeight: 500,
    fontSize: '14px',
    fontFamily: 'Rubik',
    lineHeight: 1.71,
    letterSpacing: '1.25px',
    color: theme.palette.text.primary,
  },
  menuTopContentItem: {
    backgroundColor: theme.palette.background.paper,
  },
  menuTopContentSticky: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  menuTopContentDivider: {
    width: '100%',
  },
  customMenuTopContentDivider: {
    width: '100%',
  },
  divider: {
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '85%',
  },
  lastDivider: {
    width: '100%',
  },
  subText: {
    color: theme.palette.text.secondary,
  },
  stickyButtonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    height: '60px',
    minWidth: '331px',
    width: '100%',
    position: 'sticky',
    bottom: 0,
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  innerButtonDiv: {
    display: 'flex',
    flexDirection: 'column',
  },
  flexRow: {
    paddingRight: '8px',
    paddingBottom: theme.spacing(1),
    paddingTop: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
  cancelButton: {
    width: '95px',
  },
  applyButton: {
    marginLeft: '10px',
    width: '109px',
  },
  accountListItemText: {
    minWidth: 0,
  },
  accountNamePrimary: {
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: theme.spacing(0.5),
    maxWidth: '100%',
    minWidth: 0,
  },
  accountNameValue: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  closedAccountLabel: {
    width: 160,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
}));

export default useStyles;
